let instanceCount = 0;

interface ITime {
    milliseconds: number;
    seconds: number;
    minutes: number;
}

export class TimeUtil {
    public static instance: TimeUtil;
    private systemDateTime;
    readonly time: ITime = {
        milliseconds: 0,
        seconds: 0,
        minutes: 0
    };

    public constructor() {
        ++instanceCount;
        if (instanceCount > 1) {
            throw new Error('TimeUtil: This service should not be instantiated more than once.');
        }
        TimeUtil.instance = this;
    }

    static getInstance() {
        if (TimeUtil.instance !== undefined && this.instance instanceof TimeUtil) {
            return TimeUtil.instance;
        } else {
            this.instance = new TimeUtil();
            return this.instance;
        }
    }

    startTimer() {
        let rAF;
        const rAFCallback = (callback) => {
            const count = callback;

            this.time.milliseconds = Math.floor(count % 1000);
            this.time.seconds = Math.floor((count / 1000)) % 60;
            this.time.minutes = Math.floor((count / 60000)) % 60;
            rAF = requestAnimationFrame(rAFCallback);
        };
        rAF = requestAnimationFrame(rAFCallback);
    }

    /**
     * @description Manually set the system time in seconds
     */
    setSystemTime(v: number) {
        this.systemDateTime = v;
        window.localStorage.setItem('system⏲time', v.toString());
    }

    /**
     * @description Time in seconds since Epoch
     */
    getSystemTime(): number {
        return +window.localStorage.getItem('system⏲time');
    }

    /**
     * @description Timezone UTC offset in seconds
     */
    getSystemTimezone(): number {
        const tz = +window.localStorage.getItem('system🗺timezone');
        return tz <= 0 ? tz : -1 * tz;
    }

    /**
     * @description Calculates elapsed time in seconds since timer initiation
     */
    elapsedSystemTime() {
        const correctTZOffset = this.getTimezoneOffset();
        const systemTime = new Date(this.getSystemTime() * 1000 + correctTZOffset);
        const now0 = new Date(this.getSystemTime() * 1000 + correctTZOffset);
        const milliseconds0 = now0.getMilliseconds();
        const seconds0 = now0.getSeconds();
        const minutes0 = now0.getMinutes();
        now0.setMinutes(this.time.minutes + minutes0, this.time.seconds + seconds0, this.time.milliseconds + milliseconds0);
        return (now0.getTime() - systemTime.getTime()) / 1000;
    }

    /**
     * @description Calculates elapsed time in milliseconds since timer initiation
     */
    elapsedSystemTimeMs() {
        const correctTZOffset = this.getTimezoneOffset();
        const systemTime = new Date(this.getSystemTime() * 1000 + correctTZOffset);
        const now0 = new Date(this.getSystemTime() * 1000 + correctTZOffset);
        const milliseconds0 = now0.getMilliseconds();
        const seconds0 = now0.getSeconds();
        const minutes0 = now0.getMinutes();
        now0.setMinutes(this.time.minutes + minutes0, this.time.seconds + seconds0, this.time.milliseconds + milliseconds0);
        return now0.getTime() - systemTime.getTime();
    }

    /**
     * @description Returns the timezone difference between the system time and the machine time in milliseconds
     */
    getTimezoneOffset() {
        const systemTZ = this.getSystemTimezone() * 1000;
        const machineTZOffset = (new Date()).getTimezoneOffset() * 60000;
        return machineTZOffset - systemTZ;
    }

    static getDateTimeString(dateTime): string {
        const currentDatetime = new Date(dateTime);
        return currentDatetime.getFullYear() + '-' + (currentDatetime.getMonth() + 1) + '-'
            + currentDatetime.getDate() + ' '
            + currentDatetime.getHours() + ':'
            + currentDatetime.getMinutes()
            + ':' + currentDatetime.getSeconds();

    }
}
